import JSXComponent from "../../../../dist/jsx-render/JSXComponent";
import dom from "../../../../dist/jsx-render/dom";
import { app } from "../../../Frame/App";
import { DynPopup } from "../../../Components/DynPopup";
import { BuildingplanPage } from "./BuildingplanPage";
import { IFreigabe } from "./IFreigabe";
import { IGebaeudePos } from "./IGebaeudePos";

export type DynamicSymbolsPopupProps = {
    selectedValues: number[];
    buildingplanValues: string;
    measureId: number;
}

/**Component for scanning QR codes*/
export class DynamicSymbolsPopup extends JSXComponent {
    props: DynamicSymbolsPopupProps;

    //The current element
    private element: HTMLElement;
    private imageContainer: HTMLElement;
    private buildingplanPage: BuildingplanPage;

    public newSymbols: IGebaeudePos[] = [];

    constructor(props: DynamicSymbolsPopupProps) {
        super(props);
    }

    /**Create video capture element*/
    private createElement = () => {
        this.element = <div>
            <DynPopup
                size="standard"
                showCancelButton={true}
                showCloseButton={false}
                showOkButton={false}
                showSaveButton={true}
                showFooter={true}
                onSave={(event: Event): boolean => {
                    if (this.buildingplanPage) {
                        let dynamicPins = this.buildingplanPage.dynamicPins;
                        if (app.customerService && app.customerService.onSaveClientData) {
                            app.customerService.onSaveClientData(dynamicPins);
                        }

                        return true;
                    }
                }}
                onCancel={() => {
                    if (this.buildingplanPage) { 
                        this.buildingplanPage.dynamicPins = [];
                        this.buildingplanPage.removeDynamicPins();
                    }
                }}
            >
                <div class="dynamic-symbols">
                    {this.renderImageContainerElement()}
                </div> 
            </DynPopup>
        </div>;
    }

    private renderImageContainerElement = () => {
        this.imageContainer =
            <div id="contentFrame" class="content-bg bg-white">
                <div class="d-flex flex-row title-row m-3 align-items-center border-bottom pb-2">
                    <div id="buttonPlay" class="pl-2 pr-2 mr-2 pointer d-none"><i class="fas fa-play"></i></div>
                    <div id="buttonStop" class="pl-2 pr-2 mr-2 pointer d-none"><i class="fas fa-pause"></i></div>
                    <div id="buttonLeft" class="pl-2 pr-2 mr-2 pointer"><i class="fas fa-chevron-left"></i></div>
                    <div id="buttonRight" class="pl-2 pr-2 mr-2 pointer"><i class="fas fa-chevron-right"></i></div>
                    <div class="dropdown mr-auto" id="dropdownGebaeudeFrame">
                        <a class="dropdown-toggle pointer" id="dropdownGebaeudeButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        </a>
                        <div class="dropdown-menu" id="dropdownGebaeudeMenu" aria-labelledby="dropdownGebaeudeButton">
                        </div>
                    </div>
                    <div id="buttonMaximize" class="pl-2 pr-2 pointer"><i class="fas fa-expand-alt"></i></div>
                    <div id="buttonMinimize" class="pl-2 pr-2 pointer d-none"><i class="fas fa-compress-alt"></i></div>
                </div>
                <div class="d-flex flex-row flex-grow-1 overflow-hidden m-2">
                    <div class="position-relative flex-grow-1">
                        <img id="contentImage" ressFolder="pva" />
                    </div>
                </div>
            </div>

        return this.imageContainer;
    }

    render() {
        this.createElement();
        document.body.appendChild(this.element);
        this.buildingplanPage = new BuildingplanPage();
        this.buildingplanPage.initDynamicSymbols(this.props.selectedValues, 'pva');
    }

   
}